export const RETURN_TO_PARAM = "returnTo";

/** Public doc routes should not be stored or restored as post-login destinations. */
export const POST_AUTH_REDIRECT_EXCLUDED_PATHS = [
  "/docs",
  "/docs.md",
  "/llms.txt",
  "/openapi.json",
] as const;

/**
 * Build an in-app return path (pathname + search) from a request.
 * Note: hash fragments are not available on the server.
 */
export function buildReturnToFromRequest(request: Request): string {
  const url = new URL(request.url);
  return `${url.pathname}${url.search}`;
}

export function getReturnToPathname(returnTo: string): string {
  return returnTo.split("?")[0]?.split("#")[0] ?? returnTo;
}

export function isExcludedPostAuthRedirectPath(pathOrReturnTo: string): boolean {
  const pathname = getReturnToPathname(pathOrReturnTo);
  return POST_AUTH_REDIRECT_EXCLUDED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}

/**
 * Guard against open redirects.
 * We only allow absolute-path (same-origin) navigations like "/foo?bar=baz".
 */
export function isSafeReturnTo(returnTo: string | null | undefined): boolean {
  if (!returnTo) return false;
  if (typeof returnTo !== "string") return false;
  if (!returnTo.startsWith("/")) return false;
  if (returnTo.startsWith("//")) return false;
  if (returnTo.includes("://")) return false;
  if (returnTo.includes("\n") || returnTo.includes("\r")) return false;
  if (isExcludedPostAuthRedirectPath(returnTo)) return false;
  return true;
}

/**
 * Build the auth page URL (currently "/") with a returnTo query param.
 */
export function buildAuthRedirectUrl(request: Request, authPath = "/"): string {
  const returnTo = buildReturnToFromRequest(request);
  const params = new URLSearchParams([[RETURN_TO_PARAM, returnTo]]);
  return `${authPath}?${params.toString()}`;
}

